import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

export default function RechercheResultCard({ item, section }) {
  const Icon = section.icon;

  return (
    <article className="group rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-sm transition hover:-translate-y-0.5 hover:border-[#1277B9]/50 hover:shadow-lg dark:border-slate-800 dark:bg-slate-950">
      <div className="flex items-start gap-3">
        <span
          className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border ${section.badgeClass}`}
        >
          {Icon && <Icon className="h-5 w-5" />}
        </span>

        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <span
              className={`inline-flex rounded-full border px-2.5 py-1 text-[11px] font-bold ${section.badgeClass}`}
            >
              {section.singular}
            </span>

            {item.meta && (
              <span className="line-clamp-1 text-xs font-semibold text-slate-400">
                {item.meta}
              </span>
            )}
          </div>

          <Link
            to={item.href}
            className="mt-2 block text-lg font-bold leading-snug text-slate-950 transition hover:text-[#1277B9] hover:underline dark:text-white"
          >
            {item.title}
          </Link>

          {item.excerpt && (
            <p className="mt-2 line-clamp-2 text-sm leading-7 text-slate-600 dark:text-slate-300">
              {item.excerpt}
            </p>
          )}

          <Link
            to={item.href}
            className="mt-3 inline-flex items-center gap-2 text-sm font-bold text-[#1277B9] transition hover:underline"
          >
            Ouvrir le résultat
            <FiArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </article>
  );
}